import { AngularCropperjsModule } from 'angular-cropperjs';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MedicalCampaignRoutingModule } from './medical-campaign-routing.module';
import { BasicComponent } from './components/basic/basic.component';
import { MainComponent } from './components/main/main.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { AdvanceDetailComponent } from './components/advance-detail/advance-detail.component';
import { DescriptionComponent } from './components/description/description.component';
import { SampleImagesComponent } from './components/sample-images/sample-images.component';
import { PreviewComponent } from './components/preview/preview.component';
import { NgAisModule } from 'angular-instantsearch';
import { AlgoliaMedicalComponent } from './components/algolia-medical/algolia-medical.component';
import { AlgoliaHospitalComponent } from './components/algolia-hospital/algolia-hospital.component';
import { UploadImgModule } from '../common/upload-img/upload-img.module';
import { SelectModule } from '../common/select/select.module';
import { AutoselectModule } from '../common/autoselect/autoselect.module';
import { ButtonModule } from '../common/button/button.module';
import { CaptchaModule } from '../common/captcha/captcha.module';
import { CardViewModule } from '../common/card-view/card-view.module';
import { CommonHeaderModule } from '../common/common-header/common-header.module';
import { DatepickerModule } from '../common/datepicker/datepicker.module';
import { EditorModule } from '../common/editor/editor.module';
import { HeaderModule } from '../common/header/header.module';
import { InputModule } from '../common/input/input.module';
import { IntlInputModule } from '../common/intl-input/intl-input.module';
import { PlaceAutocompleteModule } from '../common/place-autocomplete/place-autocomplete.module';
import { SacPurposeModule } from '../common/sac-purpose/sac-purpose.module';
import { PopoverLoaderModule } from '../common/popover-loader/popover-loader.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { PreviewFundraiserComponent } from '../common/preview-fundraiser/preview-fundraiser.component';

const AppCommonModules = [
  InputModule,
  ButtonModule,
  IntlInputModule,
  CardViewModule,
  CaptchaModule,
  DatepickerModule,
  SelectModule,
  AutoselectModule,
  EditorModule,
  PlaceAutocompleteModule,
  HeaderModule,
  CommonHeaderModule,
  SacPurposeModule
];

@NgModule({
  declarations: [
    BasicComponent,
    MainComponent,
    ImageUploadComponent,
    AdvanceDetailComponent,
    DescriptionComponent,
    SampleImagesComponent,
    PreviewComponent,
    AlgoliaMedicalComponent,
    AlgoliaHospitalComponent
  ],
  imports: [
    NgAisModule.forRoot(),
    CommonModule,
    MedicalCampaignRoutingModule,
    HeaderModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    MatDialogModule,
    SharedModule,
    CommonHeaderModule,
    CardViewModule,
    ReactiveFormsModule,
    FormsModule,
    AngularCropperjsModule,
    UploadImgModule,
    PopoverLoaderModule,
    PreviewFundraiserComponent,
    ...AppCommonModules,
  ],
  providers: [DatePipe],
  exports: [
    AlgoliaHospitalComponent,
    AlgoliaMedicalComponent,
    ImageUploadComponent
  ]
})
export class MedicalCampaignModule { }
